import React, { useState } from "react";
import CustomTooltip from "@/components/common-components/CustomTooltip/CustomTooltip";
import ShortString from "@/components/common-components/ShortString/ShortString";
import EditIcon from "@/components/Icons/icons/Edit";
import TickIcon from "@/components/Icons/icons/TickIcon";
import TrashIcon from "@/components/Icons/icons/TrashIcon";

export const AccordionListItem = ({ text, isActive, onClick, setCreateNewModal, setIsCreateNewModal, setIsDropdownOpen, isSystemTemplate, setIsSystemTemplate, setDeleteTemplateModal }: { text: string; isActive: boolean; onClick: () => void, setCreateNewModal: any, setIsCreateNewModal: any, setIsDropdownOpen: any, isSystemTemplate: boolean, setIsSystemTemplate: any, setDeleteTemplateModal: any }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`inbox-filter-by-campaign-item ${isActive ? 'inbox-filter-by-campaign-item-active inbox-select-template-active' : 'inbox-select-template'}  inbox-filter-by-campaign-item-accordian-conatiner`}>
      <span style={{ flex: 1 }} className={isActive ? 'text-active' : ''}>
        <ShortString name={text} stringLength={34} />
      </span>
      {isActive ? <TickIcon color={'var(--icon-highlight)'} width={26} /> : hover ? (<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
        <CustomTooltip title="Edit Template">
          <div onClick={() => { setCreateNewModal(true); setIsSystemTemplate(isSystemTemplate); setIsCreateNewModal(false); setIsDropdownOpen(false) }}>
            <EditIcon color={'var(--icon-default)'} width={20} />
          </div>
        </CustomTooltip>
        {
          !isSystemTemplate && (
            <CustomTooltip title="Delete Template">
              <div onClick={() => { setDeleteTemplateModal(true); setIsDropdownOpen(false) }}>
                <TrashIcon color={'var(--icon-default)'} width={20} />
              </div>
            </CustomTooltip>
          )}
      </div>) : null}
    </div>
  );
};